import type { UseQueryResult } from '@tanstack/react-query';
import { useBasket } from '../bff-api/baskets/useBasket';
import { useStore } from '../bff-api/stores/useStore';
import { StorageKey } from './model/StorageKey';
import { useLocalStorage } from './useLocalStorage';
import type { Store } from '../bff-api/stores/model';
import type { HookProps } from './model/HookProps';

export const useSDDStore = (props?: HookProps): UseQueryResult<Store | undefined> => {
    const { data } = useBasket();
    const basketStore = useStore(data?.c_goLocalStoreID);
    const storageStore = useLocalStorage<Store | undefined>(StorageKey.SDD_STORE);
    const pickedStore = useStore(storageStore?.data?.id);

    if (props?.preferenceForBasketValue && (basketStore.data || basketStore.isFetching)) {
        return basketStore;
    }

    if (pickedStore.data || pickedStore.isFetching) {
        return pickedStore;
    }

    return basketStore;
};
